<template>
  <div class="company-setting">
    <v-tabs
      vertical
      active-class="custom-tab-active"
      v-model="settingTab"
      background-color="transparent"
      color="cyan"
      class="tab-border-right"
    >
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll setting-tabs-height"
        style="max-height: 91vh; position: relative"
      >
        <template v-for="(tab, index) in SettingTabs">
          <v-tab
            v-if="getPermission(tab.permission + ':view')"
            :key="index"
            :disabled="tab.disabled"
            class="font-size-16 font-weight-600 px-8"
            :href="'#' + tab.key"
          >
            {{ tab.title }}
          </v-tab>
        </template>
      </perfect-scrollbar>
      <v-tabs-items v-model="settingTab">
        <template v-for="(tab, index) in SettingTabs">
          <v-tab-item
            v-if="getPermission(tab.permission + ':view')"
            :value="tab.key"
            :key="index"
          >
            <component :is="tab.template" />
          </v-tab-item>
        </template>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import EntityTemplate from "@/view/pages/profile/Setting/Entity";
import CompanyTemplate from "@/view/pages/profile/Setting/Company";
import RolePermissionTemplate from "@/view/pages/profile/Setting/RolePermission";
import BrandingTemplate from "@/view/pages/profile/Setting/Branding";
import CustomerTemplate from "@/view/pages/profile/Setting/Customer";
import PropertyTemplate from "@/view/pages/profile/Setting/Property";
import InvoiceTemplate from "@/view/pages/profile/Setting/Invoice";
import QuotationTemplate from "@/view/pages/profile/Setting/Quotation";
import PaymentTemplate from "@/view/pages/profile/Setting/Payment";
import EngineerTemplate from "@/view/pages/profile/Setting/Engineer";
import ProductTemplate from "@/view/pages/profile/Setting/Product";
import ServiceTemplate from "@/view/pages/profile/Setting/Service";
import CalendarTemplate from "@/view/pages/profile/Setting/Calendar";
import IntegrationTemplate from "@/view/pages/profile/Setting/Integrate";
import AccountTemplate from "@/view/pages/profile/Setting/Account";
import EmailTemplate from "@/view/pages/profile/Setting/EmailTemplate";
import SmsTemplate from "@/view/pages/profile/Setting/SmsTemplate";
// import LineItemTemplate from "@/view/pages/profile/Setting/LineItem";
import VisitTemplate from "@/view/pages/profile/Setting/Visit";
import ServiceFormTemplate from "@/view/pages/profile/Setting/ServiceForm";

export default {
  name: "profile-setting",
  data() {
    return {
      SettingTabs: [
        {
          disabled: false,
          key: "entity",
          template: EntityTemplate,
          title: "Entity",
          permission: "setting",
        },
        {
          disabled: false,
          key: "company",
          template: CompanyTemplate,
          title: "Company",
          permission: "setting",
        },
        {
          disabled: false,
          key: "role-permission",
          template: RolePermissionTemplate,
          title: "Role & Permission",
          permission: "setting",
        },
        {
          disabled: false,
          key: "branding",
          template: BrandingTemplate,
          title: "Branding",
          permission: "setting",
        },
        {
          disabled: false,
          key: "customer",
          template: CustomerTemplate,
          title: "Customer",
          permission: "setting",
        },
        {
          disabled: false,
          key: "property",
          template: PropertyTemplate,
          title: "Property",
          permission: "setting",
        },
        /*{
          disabled: false,
          key: "lineitem",
          template: LineItemTemplate,
          title: "Line Item",
          permission: "setting",
        },*/
        {
          disabled: false,
          key: "quotation",
          template: QuotationTemplate,
          title: "Quotation",
          permission: "setting",
        },
        {
          disabled: false,
          key: "invoice",
          template: InvoiceTemplate,
          title: "Invoice",
          permission: "setting",
        },
        {
          disabled: false,
          key: "payment",
          template: PaymentTemplate,
          title: "Payment",
          permission: "setting",
        },
        {
          disabled: false,
          key: "engineer",
          template: EngineerTemplate,
          title: "Staff",
          permission: "setting",
        },
        {
          disabled: false,
          key: "product",
          template: ProductTemplate,
          title: "Product",
          permission: "setting",
        },
        {
          disabled: false,
          key: "service",
          template: ServiceTemplate,
          title: "Service",
          permission: "setting",
        },
        {
          disabled: false,
          key: "visit",
          template: VisitTemplate,
          title: "Visit",
          permission: "setting",
        },
        {
          disabled: false,
          key: "service-form",
          template: ServiceFormTemplate,
          title: "Service Form",
          permission: "setting",
        },
        {
          disabled: false,
          key: "calendar",
          template: CalendarTemplate,
          title: "Calendar",
          permission: "setting",
        },
        {
          disabled: false,
          key: "email-template",
          template: EmailTemplate,
          title: "Email Template",
          permission: "setting",
        },
        {
          disabled: false,
          key: "SMS-template",
          template: SmsTemplate,
          title: "SMS Template",
          permission: "setting",
        },
        {
          disabled: false,
          key: "integration",
          template: IntegrationTemplate,
          title: "Integrations",
          permission: "dashboard",
        },
        {
          disabled: false,
          key: "account",
          template: AccountTemplate,
          title: "Account",
          permission: "dashboard",
        },
      ],
    };
  },
  watch: {
    settingTab(param) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Profile" },
        { title: "Setting" },
        { title: this.getTitle(param) },
      ]);
    },
  },
  methods: {
    getTitle(key) {
      const selected = this.lodash.find(this.SettingTabs, { key });
      if (selected) {
        return selected.title;
      }
      return "";
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Profile" },
      { title: "Setting" },
    ]);

    if (this.$route.query && this.$route.query.tab) {
      this.settingTab = this.$route.query.tab;

      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Profile" },
        { title: "Setting" },
        { title: this.getTitle(this.settingTab) },
      ]);
    }
  },
  computed: {
    settingTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.settingTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "company";
      },
    },
  },
};
</script>
